import React, { useState, useEffect } from 'react';
import './index.css';
import { useCalculator } from './hooks/useCalculator';
import InputPanel from './components/InputPanel';
import ResultsArea from './components/ResultsArea';

function App() {
  const { inputs, updateInput, results, loading, error, calculate } = useCalculator();

  // Theme — persist in localStorage
  const [theme, setTheme] = useState(() => localStorage.getItem('theme') || 'dark');

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('theme', theme);
  }, [theme]);

  const toggleTheme = () => setTheme(t => t === 'dark' ? 'light' : 'dark');

  return (
    <div className="app-container">
      <header className="app-header">
        <div className="header-inner">
          <div className="header-brand">
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.10rem' }}>
                <span className="header-title">ISO Steel Fire Temperature Calculator</span>
                {/* <span className="header-badge">EN 1993-1-2</span> */}
              </div>
              <div className="header-subtitle">StructGuru · Unprotected & Protected Steel</div>
            </div>
          </div>
          <nav className="header-nav">
            <a href="#about">About</a>
            <a href="https://www.eurocodes.fi/en/eurocode-3/" target="_blank" rel="noreferrer">Reference Standard</a>
            <button
              className="theme-toggle"
              onClick={toggleTheme}
              title={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
            >
              {theme === 'dark' ? '☀️' : '🌙'}
            </button>
          </nav>
        </div>
      </header>

      <div className="main-layout">
        <InputPanel
          inputs={inputs}
          updateInput={updateInput}
          results={results}
          loading={loading}
          error={error}
          onCalculate={calculate}
        />
        <main className="content-area">
          <ResultsArea results={results} inputs={inputs} />
        </main>
      </div>
    </div>
  );
}

export default App;
